import React, { useContext, useEffect, useState, useMemo } from "react";
import CustomTable from "../../../shared/custom-table/custom-table";
import { columnsStudent } from "../../../mocks/fakeData";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  Card,
  CardContent,
  Modal,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTie,
  faPlus,
  faTrash,
  faCheck,
  faBuildingUser,
  faEdit,
  faTrashCan,
  faTriangleExclamation,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  getAllStudentFromSuperTeacher,
  getAllUserByRole,
} from "../../../services/super-teacher";
import {
  addStudentGroupService,
  RemoveStudentGroupService,
} from "../../../services/group-service";
import {
  removeSubjectFromStudentService,
  addBulkSubjectsToStudentService,
  getAllSubjectsByGroupId,
} from "../../../services/subject-service";
import {
  getAllStudentRequests,
  adjustStudentOfferRequestService,
} from "../../../services/student-offer";
import CustomButton from "../../../shared/custom-button/custom-button";
import CloseIcon from "@mui/icons-material/Close";
import { RootState } from "../../../redux/store/store";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../../config/hooks/use-toast";
import CustomAutocomplete from "../../../shared/custom-autoComplete/custom-autocomplete";

const ManagementStudent = () => {
  const id = useSelector((state: RootState) => state?.user?.userData?.id);
  const [data, setData] = useState<any>([]);
  const [student, setStudent] = useState<any>([]);
  const [selectedStudent, setSelectedStudent] = useState<any>("");
  const [studentOffers, setStudentOffers] = useState<any[]>([]);
  const [selectedStudentOffer, setSelectedStudentOffer] = useState<number | null>(null);
  const selectedPeriod = "MONTHLY"; // Default period now fixed, no user selection
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddSubjectDialog, setOpenAddSubjectDialog] = useState(false);
  const [openUpdateReqDialog, setOpenUpdateReqDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [deleteGroup, setDeleteGroup] = useState<number | null>(null);
  const [selectedSubjects, setSelectedSubjects] = useState<number[]>([]); // for bulk add
  const [selectedGroupForSubject, setSelectedGroupForSubject] = useState<number | null>(null);
  const [filteredSubjectOptions, setFilteredSubjectOptions] = useState<{ label: string; value: number }[]>([]);
  const [studentRequests, setStudentRequests] = useState<any[]>([]);
  const [selectedRequestId, setSelectedRequestId] = useState<number | null>(null);
  const [updateStartDate, setUpdateStartDate] = useState<string>("");
  const [updateEndDate, setUpdateEndDate] = useState<string>("");
  const [updateStatus, setUpdateStatus] = useState<"ACCEPTED" | "REJECTED">("ACCEPTED");
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [savingRequestUpdate, setSavingRequestUpdate] = useState(false);
  const snackbarContext = useContext(SnackbarContext);

  // Filter and pagination states
  const [query, setQuery] = useState("");
  const [groupFilter, setGroupFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const studentsPerPage = 20;
  // Subscription filter: '', 'active', 'inactive'
  const [subscriptionFilter, setSubscriptionFilter] = useState<string>("");

  const mapStudentsWithOffer = (res: any) => {
    const students = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
    return students.map((student: any) => {
      let offerTitle = "";
      let start = student.startDate;
      let end = student.endDate;

      if (Array.isArray(student.requests) && student.requests.length > 0) {
        const accepted = student.requests.filter((r: any) => r.status === "ACCEPTED");
        const latest = [...accepted].sort((a: any, b: any) => {
          const dateA = new Date(a.startDate || a.createdAt || 0).getTime();
          const dateB = new Date(b.startDate || b.createdAt || 0).getTime();
          return dateB - dateA;
        })[0];

        if (latest) {
          if (latest.studentOffer?.title) {
            offerTitle = latest.studentOffer.title;
          }
          if (!start && latest.startDate) {
            start = latest.startDate;
          }
          if (!end && latest.endDate) {
            end = latest.endDate;
          }
        }
      }

      if (!offerTitle && student.studentOffer?.title) {
        offerTitle = student.studentOffer.title;
      }

      return {
        ...student,
        studentOffer: { title: offerTitle },
        startDate: start,
        endDate: end,
      };
    });
  };

  useEffect(() => {
    // Table data: students already managed by the super teacher
    getAllStudentFromSuperTeacher()
      .then((res) => {
        setData(mapStudentsWithOffer(res));
      })
      .catch((e) => {
        console.log(e);
      });

    // Dropdown options: all students on the platform
    getAllUserByRole("ROLE_STUDENT")
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
        const studentOptions = list.map((student: any) => ({
          label: student.fullName,
          value: student.id,
          email: student.email,
        }));
        setStudent(studentOptions);
      })
      .catch((e) => {
        console.log(e);
      });
    // Fetch student offers
    import("../../../services/student-offer").then(({ getAllStudentOfferService }) => {
      getAllStudentOfferService().then((res: any) => {
        setStudentOffers(Array.isArray(res) ? res : res.data || []);
      }).catch((e: any) => {
        console.log(e);
      });
    });
    // Optionally fetch periods from API if needed
  }, []);

  useEffect(() => {
    if (openAddDialog) {
      const today = new Date();
      const todayStr = new Date(today.getTime() - today.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 10);
      setStartDate(todayStr);
      setEndDate("");
    }
  }, [openAddDialog]);

  const handleAddClick = () => setOpenAddDialog(true);
  const handleAddClose = () => {
    setOpenAddDialog(false);
    setStartDate("");
    setEndDate("");
  };
  const handleDeleteClick = (row: any) => {
    setSelectedRow(row);
    setOpenDeleteDialog(true);
  };
  const handleDeleteClose = () => setOpenDeleteDialog(false);

  const handleAddSubjectClick = (row: any) => {
    setSelectedRow(row);
    setOpenAddSubjectDialog(true);
    setSelectedSubjects([]); // reset selection
    setSelectedGroupForSubject(null);
    setFilteredSubjectOptions([]);
  };

  const resetUpdateRequestForm = () => {
    setStudentRequests([]);
    setSelectedRequestId(null);
    setUpdateStartDate("");
    setUpdateEndDate("");
    setUpdateStatus("ACCEPTED");
  };

  const handleOpenUpdateReq = async (row: any) => {
    setSelectedRow(row);
    setOpenUpdateReqDialog(true);
    resetUpdateRequestForm();
    try {
      setLoadingRequests(true);
      const res = await getAllStudentRequests();
      const requests = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      const filtered = requests.filter((r: any) => r.studentId === row.id);
      setStudentRequests(filtered);
      if (filtered.length > 0) {
        const sorted = [...filtered].sort((a, b) => new Date(b.requestDate ?? b.createdAt ?? 0).getTime() - new Date(a.requestDate ?? a.createdAt ?? 0).getTime());
        const latest = sorted[0];
        setSelectedRequestId(latest.id);
        setUpdateStartDate(latest.startDate ? String(latest.startDate).slice(0, 10) : "");
        setUpdateEndDate(latest.endDate ? String(latest.endDate).slice(0, 10) : "");
        setUpdateStatus((latest.status as "ACCEPTED" | "REJECTED") ?? "ACCEPTED");
      }
    } catch (e) {
      console.log(e);
      snackbarContext?.showMessage("Erreur", "Impossible de charger les demandes de l'Eleve", "error");
    } finally {
      setLoadingRequests(false);
    }
  };

  const handleCloseUpdateReq = () => {
    setOpenUpdateReqDialog(false);
    resetUpdateRequestForm();
    setSelectedRow(null);
  };

  const handleChangeRequestSelection = (requestId: number) => {
    setSelectedRequestId(requestId);
    const req = studentRequests.find((r: any) => r.id === requestId);
    if (req) {
      setUpdateStartDate(req.startDate ? String(req.startDate).slice(0, 10) : "");
      setUpdateEndDate(req.endDate ? String(req.endDate).slice(0, 10) : "");
      setUpdateStatus((req.status as "ACCEPTED" | "REJECTED") ?? "ACCEPTED");
    }
  };

  const handleSaveRequestUpdate = async () => {
    if (!selectedRequestId) {
      snackbarContext?.showMessage("Erreur", "Choisissez une demande A mettre A jour", "error");
      return;
    }
    if (!updateStartDate || !updateEndDate) {
      snackbarContext?.showMessage("Erreur", "Renseignez les dates de debut et de fin", "error");
      return;
    }
    if (new Date(updateEndDate) < new Date(updateStartDate)) {
      snackbarContext?.showMessage("Erreur", "La date de fin doit etre posterieure A la date de debut", "error");
      return;
    }
    try {
      setSavingRequestUpdate(true);
      await adjustStudentOfferRequestService(selectedRequestId, {
        startDate: updateStartDate,
        endDate: updateEndDate,
        status: updateStatus,
      });
      const refreshed = await getAllStudentFromSuperTeacher();
      setData(mapStudentsWithOffer(refreshed));
      snackbarContext?.showMessage("Succes", "Abonnement mis A jour", "success");
      handleCloseUpdateReq();
    } catch (e) {
      console.log(e);
      snackbarContext?.showMessage("Erreur", "Mise A jour impossible", "error");
    } finally {
      setSavingRequestUpdate(false);
    }
  };
  const handleAddSubjectClose = () => {
    setOpenAddSubjectDialog(false);
    setSelectedGroupForSubject(null);
    setFilteredSubjectOptions([]);
  };
  // When group is selected, fetch all subjects for that group from the backend
  useEffect(() => {
    if (!selectedGroupForSubject) {
      setFilteredSubjectOptions([]);
      return;
    }
    // Fetch all subjects for the selected group
    getAllSubjectsByGroupId(selectedGroupForSubject).then((subjects: any) => {
      console.log('Subjects returned by getAllSubjectsByGroupId:', subjects);
      // The correct array is subjects.data (from API), or subjects.data.data
      const subjectList = Array.isArray(subjects?.data) ? subjects.data : (Array.isArray(subjects?.data?.data) ? subjects.data.data : []);
      // Get assigned subject IDs
      const assignedSubjectIds = Array.isArray(selectedRow?.subjects)
        ? selectedRow.subjects.map((s: any) => s.id)
        : [];
      // Deduplicate by ID
      const uniqueSubjectsMap = new Map();
      subjectList.forEach((subject: any) => {
        if (!uniqueSubjectsMap.has(subject.id)) {
          uniqueSubjectsMap.set(subject.id, subject);
        }
      });
      const uniqueSubjects = Array.from(uniqueSubjectsMap.values());
      setFilteredSubjectOptions(
        uniqueSubjects.map((subject: any) => ({
          label: `${subject.title || subject.speciality} (${subject.level || 'N/A'})`,
          value: subject.id,
          assigned: assignedSubjectIds.includes(subject.id),
        }))
      );
      setSelectedSubjects([]); // reset subjects when group changes
    });
  }, [selectedGroupForSubject, selectedRow]);

  // const handleDeleteSubjectClick = (row: any) => {
  //   setSelectedRow(row);
  //   setOpenDeleteSubjectDialog(true);
  // };
  // const handleDeleteSubjectClose = () => {
  //   setOpenDeleteSubjectDialog(false);
  //   setDeleteSubject(null);
  // };

  const handleSave = () => {
    if (!selectedStudent || !selectedStudentOffer || !startDate || !endDate) {
      if (snackbarContext) {
        snackbarContext.showMessage(
          "Erreur",
          "Veuillez remplir tous les champs, y compris les dates.",
          "error",
        );
      }
      return;
    }
    if (new Date(endDate) < new Date(startDate)) {
      snackbarContext?.showMessage(
        "Erreur",
        "La date de fin doit etre posterieure a la date de debut.",
        "error",
      );
      return;
    }
    addStudentGroupService(0, selectedStudent, String(selectedStudentOffer), selectedPeriod, startDate, endDate)
      .then((res) => {
        getAllStudentFromSuperTeacher()
          .then((res) => {
            setData(mapStudentsWithOffer(res));
          })
          .catch((e) => {
            console.log(e);
          });
        if (snackbarContext) {
          snackbarContext.showMessage(
            "Succes",
            "Elève ajouter avec succée",
            "success",
          );
        }
        handleAddClose();
        setSelectedStudentOffer(null);
        setStartDate("");
        setEndDate("");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleDelete = () => {
    if (selectedRow && deleteGroup) {
      RemoveStudentGroupService(deleteGroup, selectedRow.id)
        .then(() => {
          getAllStudentFromSuperTeacher()
            .then((res) => {
              setData(mapStudentsWithOffer(res));
            })
            .catch((e) => {
              console.log(e);
            });
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Élève est supprimé avec succée",
              "success",
            );
          }
          handleDeleteClose();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  // const handleSaveSubject = () => {
  //   if (selectedRow && selectedSubject) {
  //     addSubjectToStudentService(selectedRow.id, Number(selectedSubject))
  //       .then(() => {
  //         getAllStudentFromSuperTeacher()
  //           .then((res) => {
  //             setData(res.data);
  //           })
  //           .catch((e) => {
  //             console.log(e);
  //           });
  //         if (snackbarContext) {
  //           snackbarContext.showMessage(
  //             "Succes",
  //             "Matière ajoutée avec succès",
  //             "success",
  //           );
  //         }
  //         handleAddSubjectClose();
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   }
  // };

  const handleSaveSubjectsBulk = async () => {
    if (selectedRow && selectedSubjects.length > 0) {
      await addBulkSubjectsToStudentService(selectedRow.id, selectedSubjects);
      getAllStudentFromSuperTeacher()
        .then((res) => {
          setData(mapStudentsWithOffer(res));
        })
        .catch((e) => {
          console.log(e);
        });
      if (snackbarContext) {
        snackbarContext.showMessage(
          "Succes",
          "Matières ajoutées avec succès",
          "success",
        );
      }
      handleAddSubjectClose();
    }
  };

  // const handleDeleteSubject = () => {
  //   if (selectedRow && deleteSubject) {
  //     removeSubjectFromStudentService(selectedRow.id, deleteSubject)
  //       .then(() => {
  //         getAllStudentFromSuperTeacher()
  //           .then((res) => {
  //             setData(res.data);
  //           })
  //           .catch((e) => {
  //             console.log(e);
  //           });
  //         if (snackbarContext) {
  //           snackbarContext.showMessage(
  //             "Succes",
  //             "Matière supprimée avec succès",
  //             "success",
  //           );
  //         }
  //         handleDeleteSubjectClose();
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   }
  // };

  const handleDeleteSubjectSingle = async (subjectId: number) => {
    if (selectedRow && subjectId) {
      await removeSubjectFromStudentService(selectedRow.id, subjectId);
      // Update the UI immediately for better UX
      setSelectedRow((prev: any) => {
        if (!prev) return prev;
        return {
          ...prev,
          subjects: prev.subjects.filter((s: any) => s.id !== subjectId),
        };
      });
      getAllStudentFromSuperTeacher()
        .then((res) => {
          setData(mapStudentsWithOffer(res));
        })
        .catch((e) => {
          console.log(e);
        });
      if (snackbarContext) {
        snackbarContext.showMessage(
          "Succes",
          "Matière supprimée avec succès",
          "success",
        );
      }
    }
  };

  const ActionButtons: React.FC<{ row: any }> = ({ row }) => (
    <div className="flex items-center justify-center gap-4">
      <button
        onClick={() => handleAddSubjectClick(row)}
        className="group flex items-center gap-2 px-6 py-2.5 bg-[#ECFDF5] text-[#059669] font-black text-[10px] uppercase tracking-[0.2em] rounded-2xl hover:bg-[#10B981] hover:text-white transition-all duration-300 border border-[#D1FAE5] shadow-sm hover:shadow-[#D1FAE5]"
      >
        <AutoStoriesIcon className="!text-[14px] group-hover:scale-110 transition-transform" />
        Matières
      </button>
      <button
        onClick={() => handleOpenUpdateReq(row)}
        className="group flex items-center gap-2 px-6 py-2.5 bg-[#EFF6FF] text-[#2563EB] font-black text-[10px] uppercase tracking-[0.2em] rounded-2xl hover:bg-[#3B82F6] hover:text-white transition-all duration-300 border border-[#DBEAFE] shadow-sm hover:shadow-[#DBEAFE]"
      >
        <SubscriptionsIcon className="!text-[14px] group-hover:scale-110 transition-transform" />
        Abonnement
      </button>
      <button
        onClick={() => handleDeleteClick(row)}
        className="group flex items-center gap-2 px-6 py-2.5 bg-[#FFF1F2] text-[#E11D48] font-black text-[10px] uppercase tracking-[0.2em] rounded-2xl hover:bg-[#F43F5E] hover:text-white transition-all duration-300 border border-[#FFE4E6] shadow-sm hover:shadow-[#FFE4E6]"
      >
        <DeleteOutlineIcon className="!text-[14px] group-hover:scale-110 transition-transform" />
        Supprimer
      </button>
    </div>
  );
  const ActionStatus: React.FC<{ row: any }> = ({ row }) => {
    // Only show group titles, not subscription status
    return (
      <div className="flex items-center justify-center space-x-2">
        <div>
          {row?.groups
            ?.filter((item: any) => item.superTeacherId === id)
            .map((group: any) => group.title)
            .join(" ,  ")}
        </div>
      </div>
    );
  };

  const renderActions = (row: any) => <ActionButtons row={row} />;
  const renderStatus = (row: any) => <ActionStatus row={row} />;

  // Filter and pagination logic
  const filtered = useMemo(() => {
    let result = Array.from(new Map(data.map((item: any) => [item.id, item])).values());

    // Apply text search filter
    if (query) {
      const q = query.toLowerCase();
      result = result.filter((student: any) => {
        const fullName = (student.fullName || "").toLowerCase();
        const email = (student.email || "").toLowerCase();
        return fullName.includes(q) || email.includes(q);
      });
    }

    // Apply group filter
    if (groupFilter) {
      result = result.filter((student: any) => {
        return student.groups?.some((group: any) => group.title === groupFilter);
      });
    }

    // Apply subscription filter
    if (subscriptionFilter === "active") {
      result = result.filter((student: any) => student.isSubscriptionActive === true);
    } else if (subscriptionFilter === "inactive") {
      result = result.filter((student: any) => student.isSubscriptionActive === false);
    }

    return result;
  }, [data, query, groupFilter, subscriptionFilter]);

  // Pagination logic
  const totalPages = Math.ceil(filtered.length / studentsPerPage);
  const paginatedStudents = useMemo(() => {
    const startIdx = (currentPage - 1) * studentsPerPage;
    return filtered.slice(startIdx, startIdx + studentsPerPage);
  }, [filtered, currentPage]);

  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [query, groupFilter]);

  // Get unique groups for filter dropdown
  const availableGroups = useMemo<string[]>(() => {
    const groups = data.flatMap((student: any) =>
      student.groups?.filter((g: any) => g.superTeacherId === id).map((g: any) => g.title) || []
    );
    return Array.from(new Set(groups)).filter(Boolean) as string[];
  }, [data, id]);

  return (
    <div className="w-full space-y-8 p-6 lg:p-10">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <h1 className="text-3xl font-black text-title uppercase tracking-tight">
            Gestion élèves
          </h1>
          <p className="text-[10px] font-bold text-primary uppercase tracking-[0.3em] mt-1">Administration & Suivi des inscriptions</p>
        </div>
        <button 
          onClick={handleAddClick}
          className="flex items-center gap-3 px-8 py-4 bg-primary text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-primary/20 hover:bg-[#05322B] hover:-translate-y-1 transition-all duration-300"
        >
          <span>Ajouter un élève</span>
          <span className="text-xl">+</span>
        </button>
      </div>

      {/* Search and Filter Section - Glassmorphic */}
      <div className="bg-white/70 backdrop-blur-xl border border-white p-8 rounded-[2.5rem] shadow-2xl shadow-black/5">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end">
          
          <div className="lg:col-span-4 space-y-2">
            <label className="text-[10px] font-black text-title uppercase tracking-widest ml-2">Recherche</label>
            <div className="relative">
              <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-text/30" />
              <input 
                type="text"
                placeholder="Nom ou email..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="w-full h-14 pl-12 pr-4 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-2xl font-medium text-text outline-none transition-all"
              />
            </div>
          </div>

          <div className="lg:col-span-3 space-y-2">
            <label className="text-[10px] font-black text-title uppercase tracking-widest ml-2">Groupe</label>
            <select
              value={groupFilter}
              onChange={(e) => setGroupFilter(e.target.value)}
              className="w-full h-14 px-4 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-2xl font-black text-title text-[12px] uppercase tracking-wider outline-none transition-all appearance-none cursor-pointer"
            >
              <option value="">Tous les groupes</option>
              {availableGroups.map((group: string) => (
                <option key={group} value={group}>{group}</option>
              ))}
            </select>
          </div>

          <div className="lg:col-span-3 space-y-2">
            <label className="text-[10px] font-black text-title uppercase tracking-widest ml-2">Abonnement</label>
            <select
              value={subscriptionFilter}
              onChange={(e) => setSubscriptionFilter(e.target.value)}
              className="w-full h-14 px-4 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-2xl font-black text-title text-[12px] uppercase tracking-wider outline-none transition-all appearance-none cursor-pointer"
            >
              <option value="">Tous les abonnements</option>
              <option value="active">Actifs</option>
              <option value="inactive">Inactifs</option>
            </select>
          </div>

          <div className="lg:col-span-2 flex items-center gap-3">
             <button 
                onClick={() => { setQuery(""); setGroupFilter(""); setSubscriptionFilter(""); }}
                className="h-14 flex-1 flex items-center justify-center gap-2 bg-gray-50 text-text/40 font-black text-[10px] uppercase tracking-widest rounded-2xl border border-gray-100 hover:bg-white hover:text-red-500 transition-all"
                disabled={!query && !groupFilter && !subscriptionFilter}
             >
                Réinitialiser
             </button>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-4 items-center justify-between">
           <p className="text-[10px] font-bold text-text/40 uppercase tracking-widest">
              Affichage de <span className="text-primary">{paginatedStudents.length}</span> sur <span className="text-title">{filtered.length}</span> élèves
              {(query || groupFilter || subscriptionFilter) && <span className="ml-2 lowercase font-normal italic">(filtré)</span>}
           </p>
        </div>
      </div>

      <CustomTable
        columns={columnsStudent}
        //@ts-ignore
        data={paginatedStudents}
        actions={renderActions}
        status={renderStatus}
        statusName={"Groups"}
      />

      {/* Pagination Controls - Premium */}
      {filtered.length > 0 && (
        <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-6 px-4">
           <div className="text-[10px] font-bold text-text/40 uppercase tracking-[0.2em]">
              Page <span className="text-primary font-black">{currentPage}</span> sur <span className="text-title font-black">{totalPages}</span>
           </div>

           <div className="flex items-center gap-2">
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className="w-10 h-10 flex items-center justify-center rounded-xl bg-white border border-gray-100 text-text/40 hover:text-primary disabled:opacity-30 disabled:hover:text-text/40 transition-all font-black text-xs"
              >
                &laquo;
              </button>
              <button
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                className="px-6 h-10 flex items-center justify-center rounded-xl bg-white border border-gray-100 text-[10px] font-black uppercase tracking-widest text-text/60 hover:text-primary disabled:opacity-30 disabled:hover:text-text/60 transition-all"
              >
                Précédent
              </button>
              
              <div className="flex items-center gap-1 mx-2">
                 {[...Array(totalPages)].map((_, i) => {
                    const page = i + 1;
                    // Show only first, last, and pages around current
                    if (page === 1 || page === totalPages || (page >= currentPage - 1 && page <= currentPage + 1)) {
                       return (
                          <button
                             key={page}
                             onClick={() => setCurrentPage(page)}
                             className={`w-10 h-10 rounded-xl font-black text-xs transition-all ${currentPage === page ? 'bg-primary text-white shadow-lg shadow-primary/20 scale-110' : 'bg-white text-text/40 hover:text-primary hover:bg-gray-50'}`}
                          >
                             {page}
                          </button>
                       );
                    } else if (page === currentPage - 2 || page === currentPage + 2) {
                       return <span key={page} className="text-text/20">...</span>;
                    }
                    return null;
                 })}
              </div>

              <button
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                className="px-6 h-10 flex items-center justify-center rounded-xl bg-white border border-gray-100 text-[10px] font-black uppercase tracking-widest text-text/60 hover:text-primary disabled:opacity-30 disabled:hover:text-text/60 transition-all"
              >
                Suivant
              </button>
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className="w-10 h-10 flex items-center justify-center rounded-xl bg-white border border-gray-100 text-text/40 hover:text-primary disabled:opacity-30 disabled:hover:text-text/40 transition-all font-black text-xs"
              >
                &raquo;
              </button>
           </div>
        </div>
      )}

      {/* Add Student Drawer - Premium Right-Side */}
      <Modal
        open={openAddDialog}
        onClose={handleAddClose}
        className="flex justify-end backdrop-blur-sm bg-title/20"
        closeAfterTransition
      >
        <div className={`h-full w-full max-w-[550px] bg-white shadow-[-20px_0_80px_rgba(0,0,0,0.1)] outline-none transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] flex flex-col ${openAddDialog ? 'translate-x-0' : 'translate-x-full'}`}>
          {/* Drawer Header */}
          <div className="p-8 pb-6 flex items-center justify-between border-b border-gray-50 bg-white/50 backdrop-blur-md flex-shrink-0 z-30">
            <div>
              <h2 className="text-2xl font-black text-title uppercase tracking-tighter">Ajouter un élève</h2>
              <p className="text-[9px] font-black text-primary uppercase tracking-[0.4em] mt-1">Nouvelle inscription plateforme</p>
            </div>
            <button 
              onClick={handleAddClose}
              className="w-12 h-12 flex items-center justify-center rounded-2xl bg-gray-50 text-text/30 hover:bg-rose-50 hover:text-rose-500 transition-all duration-300 group"
            >
               <span className="text-2xl font-light group-hover:rotate-90 transition-transform duration-500 pointer-events-none">&times;</span>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto no-scrollbar p-8 space-y-10 bg-white">
            <section className="space-y-4">
              <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                 <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                 Sélection du compte
              </h3>
              <div className="bg-slate-50 p-6 rounded-[2.5rem] border border-slate-100">
                <p className="text-[10px] font-black text-text/40 uppercase tracking-widest mb-4 leading-relaxed">
                  Recherchez et sélectionnez l'élève que vous souhaitez inscrire à votre structure.
                </p>
                <CustomAutocomplete
                  options={student}
                  value={selectedStudent}
                  onChange={(e) => setSelectedStudent(e)}
                  placeholder="Nom ou email de l'élève..."
                  filterOption={(option, inputValue) => {
                    const val = inputValue.toLowerCase();
                    const labelMatch = typeof option.label === 'string' && option.label.toLowerCase().includes(val);
                    const emailMatch = typeof option.email === 'string' && option.email.toLowerCase().includes(val);
                    return !!(labelMatch || emailMatch);
                  }}
                />
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                 <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                 Type d'offre
              </h3>
              <div className="relative">
                <select
                  value={selectedStudentOffer ?? ""}
                  onChange={(e) => setSelectedStudentOffer(Number(e.target.value))}
                  className="w-full h-16 px-6 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-[1.5rem] font-black text-title text-[12px] uppercase tracking-wider outline-none transition-all appearance-none cursor-pointer"
                >
                  <option value="" disabled>Choisir un forfait</option>
                  {studentOffers.map((offer: any) => (
                    <option key={offer.id} value={offer.id}>{offer.title}</option>
                  ))}
                </select>
                <div className="absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none opacity-20">
                  <FilterListIcon fontSize="small" />
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                 <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                 Période de validité
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label className="text-[9px] font-black text-text/40 uppercase tracking-widest ml-4">Début</label>
                  <input 
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full h-16 px-6 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-[1.5rem] font-bold text-title outline-none transition-all"
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-[9px] font-black text-text/40 uppercase tracking-widest ml-4">Fin (Expiration)</label>
                  <input 
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full h-16 px-6 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-[1.5rem] font-bold text-title outline-none transition-all"
                  />
                </div>
              </div>
            </section>
          </div>

          <div className="p-8 bg-white border-t border-gray-100 flex gap-4 z-40 flex-shrink-0">
             <button 
                onClick={handleAddClose}
                className="px-8 h-14 rounded-2xl font-black text-[11px] uppercase tracking-widest text-text/40 hover:text-rose-500 hover:bg-rose-50 active:scale-95 transition-all duration-300"
             >
                Annuler
             </button>
             <button 
                onClick={handleSave}
                className="flex-1 h-14 bg-primary text-white rounded-2xl font-black text-[11px] uppercase tracking-[0.3em] shadow-2xl shadow-primary/30 hover:shadow-primary/50 hover:-translate-y-1 active:scale-95 transition-all duration-300 flex items-center justify-center gap-4 group"
             >
                <span>Confirmer l'inscription</span>
                <SubscriptionsIcon className="!text-[14px] group-hover:rotate-12 transition-transform duration-500" />
             </button>
          </div>
        </div>
      </Modal>

      <AnimatePresence>
        {openDeleteDialog && (
          <Modal
            open={openDeleteDialog}
            onClose={handleDeleteClose}
            className="flex items-center justify-center p-4 backdrop-blur-xl bg-title/40"
            closeAfterTransition
          >
            <motion.div 
              className="w-full max-w-[450px] bg-white rounded-[3rem] p-10 shadow-3xl text-center outline-none border border-white/20"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
            >
              <div className="w-24 h-24 rounded-[2.5rem] bg-rose-50 text-rose-500 flex items-center justify-center text-4xl mx-auto mb-8 border border-rose-100 shadow-sm relative">
                <div className="absolute inset-0 bg-rose-400/20 rounded-[2.5rem] animate-ping opacity-50"></div>
                <FontAwesomeIcon icon={faTrashCan} className="relative z-10" />
              </div>
              
              <h3 className="text-2xl font-black text-title uppercase tracking-tight mb-4 text-center">
                Désinscrire <span className="text-rose-500">l'Élève</span>
              </h3>
              
              <p className="text-sm font-medium text-text/60 leading-relaxed mb-8 px-4 text-center">
                Retirer <span className="text-[#05322B] font-black">{selectedRow?.fullName}</span> de votre structure ? cette action est irréversible.
              </p>

              <div className="w-full text-left space-y-3 mb-10">
                <label className="text-[10px] font-black text-title/40 uppercase tracking-[0.2em] ml-2">Sélectionner le groupe cible</label>
                <div className="relative group/sel">
                   <select
                     value={deleteGroup ?? ""}
                     onChange={(e) => setDeleteGroup(Number(e.target.value))}
                     className="w-full h-16 px-6 bg-slate-50 border border-slate-100 focus:bg-white focus:border-rose-500/20 rounded-2xl font-black text-title text-[11px] uppercase tracking-wider outline-none transition-all appearance-none cursor-pointer pr-12"
                   >
                     <option value="" disabled>Choisir un groupe</option>
                     {selectedRow?.groups
                       ?.filter((item: any) => item.superTeacherId === id)
                       .map((group: any) => (
                         <option key={group.id} value={group.id}>{group.title}</option>
                       ))}
                   </select>
                   <div className="absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none text-rose-500/40 group-hover/sel:text-rose-500 transition-colors">
                      <FontAwesomeIcon icon={faTriangleExclamation} className="text-[10px]" />
                   </div>
                </div>
              </div>

              <div className="flex gap-4">
                <button
                  className="flex-1 h-16 bg-slate-50 text-text/40 font-black text-[11px] uppercase tracking-widest rounded-2xl hover:bg-slate-100 transition-all duration-300 outline-none"
                  onClick={handleDeleteClose}
                >
                  Annuler
                </button>
                <button
                  className="flex-1 h-16 bg-rose-500 text-white font-black text-[11px] uppercase tracking-widest rounded-2xl shadow-xl shadow-rose-500/20 hover:bg-rose-600 hover:-translate-y-1 transition-all duration-300 outline-none"
                  onClick={handleDelete}
                >
                  Confirmer
                </button>
              </div>
            </motion.div>
          </Modal>
        )}
      </AnimatePresence>

      {/* Manage Subjects Drawer - Premium Right-Side */}
      <Modal
        open={openAddSubjectDialog}
        onClose={handleAddSubjectClose}
        className="flex justify-end backdrop-blur-sm bg-title/20"
        closeAfterTransition
      >
        <div className={`h-full w-full max-w-[650px] bg-white shadow-[-20px_0_80px_rgba(0,0,0,0.1)] outline-none transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] flex flex-col ${openAddSubjectDialog ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="p-8 pb-6 flex items-center justify-between border-b border-gray-50 bg-white/50 backdrop-blur-md flex-shrink-0 z-30">
            <div>
              <h2 className="text-2xl font-black text-title uppercase tracking-tighter">Gestion des matières</h2>
              <p className="text-[9px] font-black text-primary uppercase tracking-[0.4em] mt-1">Coordination pédagogique pour {selectedRow?.fullName}</p>
            </div>
            <button 
              onClick={handleAddSubjectClose}
              className="w-12 h-12 flex items-center justify-center rounded-2xl bg-gray-50 text-text/30 hover:bg-rose-50 hover:text-rose-500 transition-all duration-300 group"
            >
               <span className="text-2xl font-light group-hover:rotate-90 transition-transform duration-500 pointer-events-none">&times;</span>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto no-scrollbar p-8 space-y-12 bg-white">
            <section className="bg-slate-50 p-8 rounded-[3rem] border border-slate-100 space-y-8">
               <div className="space-y-4">
                  <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                    Choisir un groupe racine
                  </h3>
                  <select
                    value={selectedGroupForSubject ?? ''}
                    onChange={(e) => setSelectedGroupForSubject(Number(e.target.value))}
                    className="w-full h-16 px-6 bg-white border border-slate-200 focus:border-primary/40 rounded-[1.5rem] font-black text-title text-[12px] uppercase tracking-wider outline-none transition-all appearance-none cursor-pointer"
                  >
                    <option value="" disabled>Sélectionner un groupe</option>
                    {selectedRow?.groups?.map((group: any) => (
                      <option key={group.id} value={group.id}>{group.title}</option>
                    ))}
                  </select>
               </div>

               <div className={`space-y-4 transition-all duration-500 ${!selectedGroupForSubject ? 'opacity-30 pointer-events-none' : 'opacity-100'}`}>
                  <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                    Multi-sélection des matières
                  </h3>
                  <Select
                    multiple
                    value={Array.isArray(selectedSubjects) ? selectedSubjects : []}
                    onChange={(e) => {
                      let value = e.target.value;
                      let arr: number[] = [];
                      if (Array.isArray(value)) arr = value.map((v) => Number(v));
                      else if (typeof value === 'string') arr = value.split(',').map((v) => Number(v));
                      else if (typeof value === 'number') arr = [value];
                      setSelectedSubjects(arr);
                    }}
                    className="w-full !min-h-[4rem] !bg-white !border-slate-200 focus:!border-primary/40 !rounded-[1.5rem] !font-black !text-title !text-[12px] !uppercase !tracking-wider"
                    renderValue={(selected) =>
                      filteredSubjectOptions
                        .filter((opt) => Array.isArray(selected) && selected.includes(opt.value))
                        .map((opt) => opt.label)
                        .join(", ")
                    }
                    MenuProps={{ PaperProps: { className: "rounded-2xl shadow-xl border border-gray-50 mt-2 no-scrollbar" } }}
                  >
                    {filteredSubjectOptions.length > 0 ? (
                      filteredSubjectOptions.map((subject: any) => (
                        <MenuItem key={subject.value} value={subject.value} disabled={subject.assigned} className="font-black text-[10px] uppercase tracking-widest py-3">
                          {subject.label}
                          {subject.assigned && <span className="ml-2 text-text/30 font-normal italic lowercase">(déjà assignée)</span>}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled className="text-[10px] font-bold italic">Aucune matière disponible</MenuItem>
                    )}
                  </Select>
               </div>

               <button 
                  onClick={handleSaveSubjectsBulk}
                  disabled={!selectedGroupForSubject || selectedSubjects.length === 0}
                  className="w-full py-5 bg-primary text-white font-black text-[11px] uppercase tracking-[0.3em] rounded-2xl shadow-xl shadow-primary/20 hover:shadow-primary/40 disabled:opacity-30 hover:-translate-y-1 transition-all duration-500 flex items-center justify-center gap-4"
               >
                  <span>Appliquer les Droits</span>
                  <AutoStoriesIcon className="!text-[14px]" />
               </button>
            </section>
            
            <section className="space-y-6">
               <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse"></div>
                  Matières actuellement assignées
               </h3>
               
               <div className="space-y-6">
                 {selectedRow?.subjects?.length > 0 ? (
                   Object.entries(
                     selectedRow.subjects.reduce((acc: any, subject: any) => {
                       let groupId = (subject.groupIds && subject.groupIds[0]) || subject.groupId;
                       let groupTitle = subject.groupTitle || subject.group?.title;
                       if (!groupId || !groupTitle) {
                         const foundGroup = Array.isArray(selectedRow.groups) ? selectedRow.groups.find((g: any) => g.id === (subject.groupIds && subject.groupIds[0]) || subject.groupId || (subject.group && g.id === subject.group.id)) : null;
                         if (!groupId && foundGroup) groupId = foundGroup.id;
                         if (!groupTitle && foundGroup) groupTitle = foundGroup.title;
                       }
                       groupId = groupId || 'Autre';
                       groupTitle = groupTitle || 'Autre';
                       if (!acc[groupId]) acc[groupId] = { title: groupTitle, subjects: [] };
                       acc[groupId].subjects.push(subject);
                       return acc;
                     }, {})
                   ).map(([groupId, groupData]: any) => (
                     <div key={groupId} className="bg-white border border-gray-100 rounded-[2rem] p-6 shadow-sm">
                       <div className="text-[9px] font-black text-primary uppercase tracking-[0.3em] mb-4 flex items-center gap-2">
                          <FontAwesomeIcon icon={faBuildingUser} className="text-[10px]" />
                          {groupData.title}
                       </div>
                       <div className="flex flex-wrap gap-2">
                         {groupData.subjects.map((subject: any) => (
                           <div key={subject.id} className="group flex items-center gap-3 pl-4 pr-1 py-1 bg-slate-50 border border-slate-100 rounded-xl hover:border-red-200 transition-all">
                             <span className="text-[10px] font-black text-title uppercase tracking-wider">
                               {subject.title || subject.speciality} {subject.level && `(${subject.level})`}
                             </span>
                             <button 
                               onClick={() => handleDeleteSubjectSingle(subject.id)}
                               className="w-8 h-8 flex items-center justify-center rounded-lg text-text/20 hover:bg-rose-500 hover:text-white transition-all shadow-sm"
                             >
                               <span className="text-xl inline-block -mt-0.5">&times;</span>
                             </button>
                           </div>
                         ))}
                       </div>
                     </div>
                   ))
                 ) : (
                   <div className="py-20 text-center bg-gray-50 rounded-[3rem] border-2 border-dashed border-gray-100">
                      <div className="text-4xl opacity-20 mb-4">📚</div>
                      <p className="text-[10px] font-black text-text/20 uppercase tracking-[0.4em]">Aucun droit d'accès défini</p>
                   </div>
                 )}
               </div>
            </section>
          </div>
        </div>
      </Modal>

      {/* Update Student Subscription Drawer - Premium Right-Side */}
      <Modal
        open={openUpdateReqDialog}
        onClose={handleCloseUpdateReq}
        className="flex justify-end backdrop-blur-sm bg-title/20"
        closeAfterTransition
      >
        <div className={`h-full w-full max-w-[550px] bg-white shadow-[-20px_0_80px_rgba(0,0,0,0.1)] outline-none transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] flex flex-col ${openUpdateReqDialog ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="p-8 pb-6 flex items-center justify-between border-b border-gray-50 bg-white/50 backdrop-blur-md flex-shrink-0 z-30">
            <div>
              <h2 className="text-2xl font-black text-title uppercase tracking-tighter">Mise à jour Abonnement</h2>
              <p className="text-[9px] font-black text-primary uppercase tracking-[0.4em] mt-1">Gestion des droits d'accès</p>
            </div>
            <button 
              onClick={handleCloseUpdateReq}
              className="w-12 h-12 flex items-center justify-center rounded-2xl bg-gray-50 text-text/30 hover:bg-rose-50 hover:text-rose-500 transition-all duration-300 group"
            >
               <span className="text-2xl font-light group-hover:rotate-90 transition-transform duration-500 pointer-events-none">&times;</span>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto no-scrollbar p-8 space-y-10 bg-white">
            <div className="flex items-center gap-6 p-6 bg-slate-50 rounded-[2rem] border border-slate-100">
               <div className="w-16 h-16 rounded-2xl bg-white shadow-inner flex items-center justify-center text-3xl">👤</div>
               <div>
                  <p className="text-[9px] font-black text-text/30 uppercase tracking-[0.3em] mb-1">Élève sous contrat</p>
                  <p className="text-lg font-black text-title uppercase tracking-tighter">{selectedRow?.fullName}</p>
               </div>
            </div>

            {loadingRequests ? (
              <div className="py-20 text-center space-y-4 animate-pulse">
                <div className="w-12 h-12 border-2 border-primary/20 border-t-primary rounded-full animate-spin mx-auto"></div>
                <p className="text-[9px] font-black text-text/30 uppercase tracking-[0.3em]">Synchronisation des demandes...</p>
              </div>
            ) : studentRequests.length === 0 ? (
              <div className="py-20 text-center border-2 border-dashed border-gray-100 rounded-[3rem] bg-gray-50/50">
                <p className="text-[10px] font-black text-text/30 uppercase tracking-[0.4em]">Aucune historique de demande</p>
              </div>
            ) : (
              <div className="space-y-10">
                <section className="space-y-4">
                  <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                    Dossier d'inscription
                  </h3>
                  <select
                    value={selectedRequestId ?? ""}
                    onChange={(e) => handleChangeRequestSelection(Number(e.target.value))}
                    className="w-full h-16 px-6 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/40 rounded-[1.5rem] font-black text-title text-[12px] uppercase tracking-wider outline-none transition-all appearance-none cursor-pointer"
                  >
                    <option value="" disabled>Sélectionner une requête</option>
                    {studentRequests.map((req: any) => (
                      <option key={req.id} value={req.id}>
                        {req.studentOffer?.title || "Offre Standard"} — {req.status}
                      </option>
                    ))}
                  </select>
                </section>

                <section className="space-y-4">
                  <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                    Dates d'éligibilité
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <label className="text-[9px] font-black text-text/40 uppercase tracking-widest ml-4">Activation</label>
                      <input 
                        type="date"
                        value={updateStartDate}
                        onChange={(e) => setUpdateStartDate(e.target.value)}
                        className="w-full h-16 px-6 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-[1.5rem] font-bold text-title outline-none transition-all"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="text-[9px] font-black text-text/40 uppercase tracking-widest ml-4">Expiration</label>
                      <input 
                        type="date"
                        value={updateEndDate}
                        onChange={(e) => setUpdateEndDate(e.target.value)}
                        className="w-full h-16 px-6 bg-gray-50 border border-gray-100 focus:bg-white focus:border-primary/20 rounded-[1.5rem] font-bold text-title outline-none transition-all"
                      />
                    </div>
                  </div>
                </section>

                <section className="space-y-4">
                  <h3 className="text-[11px] font-black text-title uppercase tracking-widest flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                    Décision de validation
                  </h3>
                  <div className="grid grid-cols-2 gap-3 p-2 bg-gray-50 rounded-[1.5rem] border border-gray-100">
                     <button 
                        onClick={() => setUpdateStatus("ACCEPTED")}
                        className={`h-14 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all duration-300 ${updateStatus === 'ACCEPTED' ? 'bg-white text-[#10B981] shadow-xl shadow-black/5 ring-1 ring-[#10B981]/10' : 'bg-transparent text-text/30 hover:text-primary'}`}
                     >
                        Approuver
                     </button>
                     <button 
                        onClick={() => setUpdateStatus("REJECTED")}
                        className={`h-14 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all duration-300 ${updateStatus === 'REJECTED' ? 'bg-white text-[#EF4444] shadow-xl shadow-black/5 ring-1 ring-[#EF4444]/10' : 'bg-transparent text-text/30 hover:text-primary'}`}
                     >
                        Rejeter
                     </button>
                  </div>
                </section>
              </div>
            )}
          </div>

          <div className="p-8 bg-white border-t border-gray-100 flex gap-4 z-40 flex-shrink-0">
             <button 
                onClick={handleCloseUpdateReq}
                className="px-8 h-14 rounded-2xl font-black text-[11px] uppercase tracking-widest text-text/40 hover:text-rose-500 hover:bg-rose-50 active:scale-95 transition-all duration-300"
             >
                Abandonner
             </button>
             <button 
                onClick={handleSaveRequestUpdate}
                disabled={savingRequestUpdate || studentRequests.length === 0}
                className="flex-1 h-14 bg-primary text-white rounded-2xl font-black text-[11px] uppercase tracking-[0.3em] shadow-2xl shadow-primary/30 hover:shadow-primary/50 hover:-translate-y-1 active:scale-95 transition-all duration-300 flex items-center justify-center gap-4 group"
             >
                <span>{savingRequestUpdate ? "Traitement..." : "Appliquer les Changements"}</span>
                <div className="w-6 h-6 rounded-lg bg-white/20 flex items-center justify-center group-hover:rotate-[360deg] transition-transform duration-700">
                   <FontAwesomeIcon icon={faCheck} className="text-[10px]" />
                </div>
             </button>
          </div>
        </div>
      </Modal>

      {/* Delete Subject Dialog */}
      {/* <Dialog
        open={openDeleteSubjectDialog}
        onClose={handleDeleteSubjectClose}
        fullWidth
        maxWidth="md"
      >
        <Box className="p-6">
          <DialogTitle className="flex items-center justify-between">
            <p className="text-2xl text-title font-montserrat_bold">
              Supprimer Matière de l'élève
            </p>
            <IconButton onClick={handleDeleteSubjectClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="space-y-6">
            <p>
              Êtes-vous sûr de vouloir supprimer cette matière de l'élève{" "}
              <strong>{selectedRow?.fullName}</strong> ?
            </p>
            <FormControl fullWidth className="mb-4">
              <label>Choisir Matière à supprimer</label>
              <Select
                labelId="select-delete-subject-label"
                value={deleteSubject}
                onChange={(e) => setDeleteSubject(e.target.value as number)}
              >
                {selectedRow?.subjects?.map((subject: any) => (
                  <MenuItem key={subject.id} value={subject.id}>
                    {subject.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className="flex justify-end mt-6 space-x-4">
              <Button
                className={"w-44 rounded-2xl border"}
                variant="outlined"
                color={"error"}
                onClick={handleDeleteSubjectClose}
              >
                Annuler
              </Button>
              <CustomButton
                text={"Supprimer"}
                width={"w-44"}
                onClick={handleDeleteSubject}
              />
            </div>
          </DialogContent>
        </Box>
      </Dialog> */}
    </div>
  );
};

export default ManagementStudent;
